import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimations} from '@angular/platform-browser/animations';
import {includeBearerTokenInterceptor, KeycloakService, provideKeycloak} from 'keycloak-angular';
import {environment} from '../environments/environment';
import {AlertService} from './services/alert.service';
import {HttpClient, provideHttpClient, withInterceptors} from '@angular/common/http';
import {AppMaterialModule} from './app-material/app-material.module';
import {OrderModule} from 'ngx-order-pipe';
import {ApiModule, BASE_PATH} from './core/modules/openapi';
import {MatError} from '@angular/material/form-field';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";


export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloak(environment.keycloak),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: BASE_PATH, useValue: environment.baseUrl
    },
    KeycloakService,
    AlertService,
    ApiModule,
    HttpClient,
    AppMaterialModule,
    OrderModule,
    MatError,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] }
  ],
};

